import ButtonCustom from "@/components/common/ui/button";
import DialogCustom from "@/components/common/ui/dialog";
import { useTranslation } from "@/config/i18n";

type Props = {
  dialogConfirmEditVisible: boolean;
  setDialogConfirmEditVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleChangeStatusUser: (actionType: string) => Promise<void>;
  loadingGlobal: boolean;
  actionType: string;
  title: string;
  content: string;
};

const UserManagementModalConfirm = ({
  dialogConfirmEditVisible,
  setDialogConfirmEditVisible,
  handleChangeStatusUser,
  loadingGlobal,
  actionType,
  title,
  content,
}: Props) => {
  const [t] = useTranslation('');

  return (
    <DialogCustom
      header={title}
      visible={dialogConfirmEditVisible}
      className="w-[516px]"
      headerClassName="border-b border-gray-200 !py-[13px]"
      contentClassName="border-b border-gray-200 !p-[16px] !text-[16px] !leading-[24px] text-center text-gray-900 whitespace-pre-line"
      onHide={() => setDialogConfirmEditVisible(false)}
      footer={
        <div className="flex gap-4 justify-end">
          <ButtonCustom
            type="button"
            className="!rounded-md"
            severity="secondary"
            onClick={() => setDialogConfirmEditVisible(false)}
          >
            {t('user_management.approve_confirm.cancel_button')}
          </ButtonCustom>
          <ButtonCustom
            type="button"
            className="!rounded-md"
            loading={loadingGlobal}
            onClick={async () =>
              await handleChangeStatusUser(actionType)
            }
          >
            {t('user_management.approve_confirm.confirm_button')}
          </ButtonCustom>
        </div>
      }
    >
      {content}
    </DialogCustom>
  )
}

export default UserManagementModalConfirm;